export default {
  // -----------------
  // -----元素属性-----
  // -----------------
  /** zh-cn */
  火: "火",
  风: "风",
  水: "水",
  光: "光",
  暗: "暗",
  /** en */
  Fire: "火",
  Wind: "风",
  Water: "水",
  Light: "光",
  Darkness: "暗",
  /** ja */
  // 火: "火",
  風: "风",
  // 水: "水",
  // 光: "光",
  闇: "暗",
  /** ko */
  불: "火",
  바람: "风",
  물: "水",
  빛: "光",
  어둠: "暗",
  /** zh-hk */
  // 火: "火",
  // 風: "风",
  // 水: "水",
  // 光: "光",
  // 暗: "暗"

  // -----------------
  // -----攻击属性-----
  // -----------------
  /** zh-cn */
  物理: "物理",
  魔法: "魔法",
  /** en */
  Physical: "物理",
  Magic: "魔法",
  /** ja */
  // 物理: "物理",
  // 魔法: "魔法",
  /** ko */
  물리: "物理",
  마법: "魔法",
  /** zh-hk */
  // 物理: "物理",
  // 魔法: "魔法",

  // -----------------
  // -----技能类型-----
  // -----------------
  /** zh-cn */
  生命力: "生命力",
  攻击力: "攻击力",
  魔法力: "魔法力",
  致命率: "致命率",
  致命伤害: "致命伤害",
  防御力: "防御力",
  魔法抵抗: "魔法抵抗",
  火属性伤害: "火属性伤害",
  风属性伤害: "风属性伤害",
  水属性伤害: "水属性伤害",
  光属性伤害: "光属性伤害",
  暗属性伤害: "暗属性伤害",
  火属性抵抗: "火属性抵抗",
  风属性抵抗: "风属性抵抗",
  水属性抵抗: "水属性抵抗",
  属性抵抗: "属性抵抗",
  /** en */
  HP: "生命力",
  ATK: "攻击力",
  "Magic ATK": "魔法力",
  "Crit Rate": "致命率",
  "Crit DMG": "致命伤害",
  DEF: "防御力",
  "Magic Resist": "魔法抵抗",
  "Fire DMG": "火属性伤害",
  "Wind DMG": "风属性伤害",
  "Water DMG": "水属性伤害",
  "Light DMG": "光属性伤害",
  "Darkness DMG": "暗属性伤害",
  "Fire Resist": "火属性抵抗",
  "Wind Resist": "风属性抵抗",
  "Water Resist": "水属性抵抗",
  "Property Resist": "属性抵抗",
  /** ja */
  // HP: "生命力",
  攻撃力: "攻击力",
  // 魔法力: "魔法力",
  クリ率: "致命率",
  クリダメ: "致命伤害",
  // 防御力: "防御力",
  // 魔法抵抗: "魔法抵抗",
  火属性ダメ: "火属性伤害",
  風属性ダメ: "风属性伤害",
  水属性ダメ: "水属性伤害",
  光属性ダメ: "光属性伤害",
  闇属性ダメ: "暗属性伤害",
  // 火属性抵抗: "火属性抵抗",
  風属性抵抗: "风属性抵抗",
  // 水属性抵抗: "水属性抵抗",
  // 属性抵抗: "属性抵抗"

  /** ko */
  생명력: "生命力",
  공격력: "攻击力",
  마법력: "魔法力",
  치명확률: "致命率",
  치명피해: "致命伤害",
  방어력: "防御力",
  마법저항: "魔法抵抗",
  "불 속성피해": "火属性伤害",
  "바람 속성피해": "风属性伤害",
  "물 속성피해": "水属性伤害",
  "빛 속성피해": "光属性伤害",
  "어둠 속성피해": "暗属性伤害",
  "불 속성저항": "火属性抵抗",
  "바람 속성저항": "风属性抵抗",
  "물 속성저항": "水属性抵抗",
  속성저항: "属性抵抗",

  /** zh-hk */
  // 生命力: "生命力",
  攻擊力: "攻击力",
  // 魔法力: "魔法力",
  // 致命率: "致命率",
  致命傷害: "致命伤害",
  防禦力: "防御力",
  // 魔法抵抗: "魔法抵抗",
  火屬性傷害: "火属性伤害",
  風屬性傷害: "风属性伤害",
  水屬性傷害: "水属性伤害",
  光屬性傷害: "光属性伤害",
  暗屬性傷害: "暗属性伤害",
  火屬性抵抗: "火属性抵抗",
  風屬性抵抗: "风属性抵抗",
  水屬性抵抗: "水属性抵抗",
  屬性抵抗: "属性抵抗"
};
